import React from 'react';
import { useTranslation } from 'react-i18next';
import './EsmCorrelationDiagram.scss';

const EsmCorrelationDiagram = () => {
  const { t } = useTranslation();

  return (
    <div className="esm-correlation-diagram">
      {/* Tiêu đề */}
      <div className="header-titles">
        <h2>{t("esm_correlation_diagram.title")}</h2>
      </div>

      {/* Container chính */}
      <div className="main-container">
        
        {/* Người dùng */}
        <div className="top-users">
          <div className="user-box">{t("esm_correlation_diagram.web_user")}</div>
          <div className="user-box">{t("esm_correlation_diagram.app_user")}</div>
        </div>
        
        {/* Mũi tên xuống */}
        <div className="arrow-down">
          <div className="arrow-body"></div>
          <div className="arrow-head"></div>
        </div>

        {/* Nền tảng Master */}
        <div className="master-platform">
          <div className="platform-title">{t("esm_correlation_diagram.master_platform")}</div>
          
          <div className="sub-platforms">
            <div className="sub-box">{t("esm_correlation_diagram.sub_platform_1")}</div>
            <div className="sub-box">{t("esm_correlation_diagram.sub_platform_2")}</div>
            <div className="sub-box">{t("esm_correlation_diagram.sub_platform_3")}</div>
            <div className="dots">...</div>
            <div className="sub-box">{t("esm_correlation_diagram.sub_platform_n")}</div>
          </div>

          <div className="mobile-scroll-hint">
            <span>↔ Cuộn ngang để xem toàn bộ bảng</span>
          </div>

          <div className="data-grid-container">
            <table className="data-grid-table">
              <thead>
                <tr>
                  <th>{t("esm_correlation_diagram.token")}</th>
                  <th>{t("esm_correlation_diagram.consensus")}</th>
                  <th>{t("esm_correlation_diagram.pow_pos")}</th>
                  <th>{t("esm_correlation_diagram.smart_contact")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{t("esm_correlation_diagram.call")}</td>
                  <td>{t("esm_correlation_diagram.tim_kiem")}</td>
                  <td>{t("esm_correlation_diagram.so_sanh")}</td>
                  <td>{t("esm_correlation_diagram.trai_nghiem")}</td>
                </tr>
                <tr>
                  <td>{t("esm_correlation_diagram.dang_ky")}</td>
                  <td>{t("esm_correlation_diagram.thong_tin_yt")}</td>
                  <td>{t("esm_correlation_diagram.truy_xuat")}</td>
                  <td>{t("esm_correlation_diagram.mua_san_pham")}</td>
                </tr>
                <tr>
                  <td>{t("esm_correlation_diagram.lua_chon_bs")}</td>
                  <td>{t("esm_correlation_diagram.nganh_dv_khac")}</td>
                  <td>{t("esm_correlation_diagram.lich_su_gd")}</td>
                  <td>{t("esm_correlation_diagram.kenh_tap_doan")}</td>
                </tr>
                <tr>
                  <td>{t("esm_correlation_diagram.dv_ho_tro")}</td>
                  <td>{t("esm_correlation_diagram.giao_dich_ncc")}</td>
                  <td>{t("esm_correlation_diagram.tai_ho_so")}</td>
                  <td>{t("esm_correlation_diagram.ho_so_tt")}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="infra-layers">
            <div className="layer-box">{t("esm_correlation_diagram.infra_arch")}</div>
            <div className="layer-box">{t("esm_correlation_diagram.infra_cloud")}</div>
            <div className="layer-box">{t("esm_correlation_diagram.blockchain")}</div>
          </div>
        </div>

        {/* Mũi tên lên */}
        <div className="arrow-up">
          <div className="arrow-head"></div>
          <div className="arrow-body"></div>
        </div>

        {/* Đối tác */}
        <div className="bottom-partners">
          <div className="partner-box">{t("esm_correlation_diagram.tech_partner")}</div>
          <div className="partner-box">{t("esm_correlation_diagram.tech_partner")}</div>
        </div>

      </div>
    </div>
  );
};

export default EsmCorrelationDiagram;
